import { defineMessages } from 'react-intl';

const trns = defineMessages({
  noGeolocationEnabled: {
    id: 'iyO9jt',
    defaultMessage:
      'Геолокація вимкнена. Увімкніть геолокацію в налаштуваннях браузера для використання цієї функції'
  },
  unExpectedError: {
    id: 'hH/z0X',
    defaultMessage: 'На жаль, трапилась несподівана помилка. Спробуйте пізніше'
  },
  noInternetConnect: {
    id: '35rK5q',
    defaultMessage:
      'Шановний користувач, можливі помилки в роботі сайту через ваш нестабільний інтернет.'
  },
  requiredFieldLabel: {
    id: 'asJvhP',
    defaultMessage: "Обов'язкове полe"
  },
  incorrectPhoneNumberLabel: {
    id: 'kGmugO',
    defaultMessage: 'Поле повинно відповідати формі +380-XX-XXX-XX-XX'
  },
  maxLength: {
    id: 'CedckJ',
    defaultMessage: 'Максимальна кількість символів {maxLength}'
  },
  incorrectPhoneCode: {
    id: 'XMx74P',
    defaultMessage: 'Некоректний код мобільного оператора'
  }
});

export default trns;
